import { useCallback } from "react";
import { isBoolean } from "lodash";

import { useForm, useFormState } from "../..";

const mapCheckboxBooleanToOption = (v) => {
  if (isBoolean(v)) return v ? "Checked" : "Unchecked";

  return null;
};

const mapCheckboxOptionToBoolean = (v) => {
  return v === "Checked";
};

export function useFieldDetailsForm(field, onSave) {
  const { description, required, defaultValue, ...restField } = field;

  const isCheckbox = useCallback(() => {
    return field?.type?.id === "CHECKBOX";
  }, [field]);

  const generateDefaultField = useCallback(() => {
    const generateCheckboxField = () => {
      return {
        value: mapCheckboxBooleanToOption(defaultValue),
        options: ["Checked", "Unchecked"],
      };
    };

    return {
      ...restField,
      ...(isCheckbox() ? generateCheckboxField() : { value: defaultValue }),
      id: "defaultValue",
      name: "Default Value",
      isCheckbox: isCheckbox(),
      required: false,
    };
  }, [defaultValue, restField, isCheckbox]);

  const defaultField = generateDefaultField();
  const formProps = useForm({
    mode: "onChange",
    defaultValues: {
      description: description,
      required: required,
      defaultValue: defaultField.value,
    },
  });
  const { isValid, defaultValues } = useFormState({
    control: formProps.control,
  });

  return {
    defaultField: defaultField,
    formProps: formProps,
    description: defaultValues.description,
    required: defaultValues.required,
    isValid: isValid,
    onSubmit: (data) => {
      return onSave({
        ...data,
        defaultValue: defaultField.isCheckbox
          ? mapCheckboxOptionToBoolean(data.defaultValue)
          : data.defaultValue,
      });
    },
  };
}

export default useFieldDetailsForm;
